export default "__VITE_ASSET__CWNQQt2o__"